import {
    Checkbox,
    createStyles,
    FormControl,
    FormControlLabel,
    makeStyles,
    Typography,
    withStyles
} from '@material-ui/core';
import clsx from 'clsx';
import { useField } from 'formik';
import { useTranslation } from 'src/app/i18n';
import { createResponsiveFontSize } from 'src/utils/helpers/theme';
import { ErrorText } from './FormInputs';
import Link from 'next/link';

const SubtitleText = withStyles(() => ({
    root: { ...createResponsiveFontSize(-1) }
}))((props) => <Typography component="span" {...props} />);

const MainGreenText = withStyles((theme) => ({
    root: {
        color: theme.palette.primary.main
    }
}))(SubtitleText);

const MainSecondaryText = withStyles((theme) => ({
    root: {
        color: theme.palette.secondary.dark
    }
}))(SubtitleText);

const useStyles = makeStyles((theme) =>
    createStyles({
        checkboxContainer: { marginBottom: 0, alignItems: 'flex-start' },
        checkbox: { color: theme.palette.grey[200], padding: `0px ${theme.spacing(2)}px` },
        checkboxLabel: {
            marginBottom: 0,
            color: theme.palette.grey['200']
        }
    })
);
interface Props {
    classes?: { root?: string; label?: string };
    terms: boolean;
    toggleTerms: (_: boolean) => void;
    name: string;
}

const TermsCheckbox = ({ classes, terms, toggleTerms, ...props }: Props) => {
    const checkClasses = useStyles();
    const { t } = useTranslation('common');
    const [field, meta] = useField(props);
    return (
        <FormControl>
            <FormControlLabel
                classes={{
                    root: clsx(checkClasses.checkboxContainer, classes?.root),
                    label: checkClasses.checkboxLabel
                }}
                control={<Checkbox className={checkClasses.checkbox} color="default" {...field} />}
                label={
                    <>
                        <SubtitleText>{t('form.agree')}</SubtitleText>
                        {/* <a href="/legal">
                            <GreenText>{` ${t('form.terms')}`}</GreenText>
                        </a>
                        , */}
                        <Link href="/legal">
                            <a>
                                <MainSecondaryText>{` ${t('form.privacy')}`}</MainSecondaryText>
                            </a>
                        </Link>
                        <Link href="/legal">
                            <a style={{ color: 'white' }}>
                                <SubtitleText>{` ${t('and')}`}</SubtitleText>
                            </a>
                        </Link>
                        <Link href="/legal/#text-head-15">
                            <a>
                                <MainGreenText>{` ${t('form.agreement')}`}</MainGreenText>
                            </a>
                        </Link>
                        .
                    </>
                }
            />
            <ErrorText meta={meta} />
        </FormControl>
    );
};

export default TermsCheckbox;
